var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "download-link tender-font underline pointer",
      on: { click: _vm.download },
    },
    [_vm._v("\n  " + _vm._s(_vm.doc.filename) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }